<template>
  <v-main class="ml-6 mt-3">
    <v-row dense>
      <v-col cols="12">
        <h3>Overview unlisted accommodations</h3>
      </v-col>
    </v-row>
    <v-row dense class="mt-3">    
        <v-col cols="1">
            <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params" show_progress />
        </v-col> 
    </v-row>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
    
    export default {
        components: {
            navBar,
            btn_create_excel,
        },
        data() {
            return {
                report: "ares/json/ares/task/inpt/ovrz/ovrz6.p",      
                report_params: {},
                report_request: "ovrz6",
            }
        },
    }
</script> 
